module.exports = __webpack_public_path__ + "static/media/scalability.7962baf0.svg";